import React from 'react';
import type { NavigationPermissionRequirement } from '@/types/navigation-permissions';

export type { SidebarMode } from '@/config/sidebar-config';

export const SIDEBAR_TOOLTIP_CLASSES =
  'z-[200] rounded-xl border border-gray-100 bg-white/95 backdrop-blur-md px-3 py-2.5 text-gray-900 shadow-md';

export type CompactGroup = 'primary' | 'more';

export interface SidebarNavSubItem {
  name: string;
  href: string;
  requiredPermission?: NavigationPermissionRequirement;
}

export interface SidebarNavItem {
  id?: string;
  name: string;
  compactName?: string;
  icon: string | React.ComponentType<{ className?: string }>;
  href: string;
  badge?: string;
  subItems?: SidebarNavSubItem[];
  requiredPermission?: NavigationPermissionRequirement;
  badgeType?: 'default' | 'arrow' | 'dot';
  isSeparator?: boolean;
  isSectionHeader?: boolean;
  sectionTitle?: string;
  shortcut?: string;
  disabled?: boolean;
  compactGroup?: CompactGroup;
  onAction?: () => void;
  onPrefetch?: () => void;
}

export interface ProgramSteps {
  profile: string;
  upload_reports: string;
  thrive_check: string;
  intake_call: string;
  thyrocare: string;
  neurowyzer: string;
  in_center: string;
  concierge_call: string;
}

export interface ThriveData {
  program_steps: ProgramSteps;
}

export interface ProgramEnrollment {
  user_program_enrollment_id: string;
  program_name: string;
  program_data: ThriveData | null;
  is_active?: boolean;
  delivery_mode?: 'online' | 'offline';
  disable_in_center?: 'true' | 'false';
  show_intake_call?: 'true' | 'false';
}
